import React from "react";
import styled from "styled-components";
// Assets

export default function Contact() {
  return (
    <Wrapper id="contact">
      <div>
        <div className="container">
          <HeaderInfo>
            <h1 className="font40 extraBold text-center mb-20">
              Let's get in touch
            </h1>
          </HeaderInfo>
          <div className="row" style={{ paddingBottom: "30px" }}>
            <div className="col-xs-12 col-sm-12 col-md-5 col-lg-5 pr-4">
              <Form>
                <label className="font13">Name</label>
                <input
                  type="text"
                  id="fname"
                  name="fname"
                  className="font20 extraBold"
                />
                <label className="font13">Email</label>
                <input
                  type="text"
                  id="email"
                  name="email"
                  className="font20 extraBold"
                />
                <label className="font13">Subject</label>
                <input
                  type="text"
                  id="subject"
                  name="subject"
                  className="font20 extraBold"
                />
                <label className="font13">Message</label>
                <textarea
                  rows="4"
                  cols="50"
                  type="text"
                  id="message"
                  name="message"
                  className="font20 extraBold"
                />
              </Form>
              <SumbitWrapper className="flex">
                <ButtonInput
                  type="submit"
                  value="Send"
                  className="btn btn-primary"
                  style={{ maxWidth: "220px" }}
                />
              </SumbitWrapper>
            </div>
            <div className="col-xs-12 col-sm-12 col-md-7 col-lg-7 footer-box flex">
              <div className="flexColumn">
                <h2>Corporate Office</h2>
                <p>
                  Plot No. 530, Udyog Vihar Phase - 5,
                  <br />
                  Gurgaon, Haryana - 122016, India
                  <br />
                  Contact: +91 9810061994
                  <br />
                  <a
                    target="_blank"
                    rel="noreferrer"
                    href="http://www.shripatigroup.com"
                  >
                    <font color="#07c9e4">www.shripatigroup.com</font>
                  </a>
                  <br />
                  <a
                    target="_blank"
                    rel="noreferrer"
                    href="http://www.all-day.in"
                  >
                    <font color="#07c9e4">www.all-day.in</font>
                  </a>
                </p>
              </div>
              <div className="flexColumn">
                <h2>Contact Us</h2>
                <p>
                  Rajesh Handa
                  <br />
                  <small>Director & CEO</small>
                  <br />
                  <a href="mailto:rajesh.h@shripatigroup.com">
                    <font color="#07c9e4">rajesh.h@shripatigroup.com</font>
                  </a>
                  <br />
                  Mobile: +91 9810061994
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Wrapper>
  );
}

const Wrapper = styled.section`
  width: 100%;
`;
const HeaderInfo = styled.div`
  padding: 60px 0 30px 60px;
  @media (max-width: 860px) {
    text-align: center;
  }
`;
const Form = styled.form`
  padding: 10px 0 30px 0;
  input,
  textarea {
    width: 100%;
    background-color: transparent;
    border: 0px;
    outline: none;
    box-shadow: none;
    border-bottom: 1px solid #707070;
    height: 30px;
    margin-bottom: 30px;
  }
  textarea {
    min-height: 100px;
  }
  @media (max-width: 860px) {
    padding: 30px 0;
  }
`;
const ButtonInput = styled.input`
  border: 1px solid #7620ff;
  background-color: #7620ff;
  width: 100%;
  padding: 15px;
  outline: none;
  color: #fff;
  :hover {
    background-color: #580cd2;
    border: 1px solid #7620ff;
    color: #fff;
  }
  @media (max-width: 991px) {
    margin: 0 auto;
  }
`;

const SumbitWrapper = styled.div`
  @media (max-width: 991px) {
    width: 100%;
    margin-bottom: 50px;
  }
`;
